import {Base,Axios} from "@/api/Base"

export class PaymentPersistency extends Base {
    path = "payment/persistency";
}